<template>
  <div v-loading.fullscreen.lock="loadingContent" element-loading-text="Aguarde um momento...">

    <Guia :showGuia="showGuia" :consulta="formData"/>
    
      <ed-form :data="formData" :response="response" :config="config" :itens="formDataItems">
        <div slot="form-footer" >
            <div class="row">

              <div class="col-md-12 text-center mt-5" v-if="formData.result && formData.result.tipo_status.bloqueado == 0">
                <ed-button 	
                  v-if="formData.id_tipo_status == 54"
                  icon="fa fa-floppy-o"
                  type="success"
                  size="big"
                  @click="salvar"
                  :loading="loadingSave"
                  value="Salvar Consulta"
                />

                <div class="col-md-12 text-center mt-2">
                  <ed-button 	
                    icon="fa fa-file-pdf-o"
                    type="warning"
                    size="big"
                    @click="onGuia"
                    value="Gerar Guia de Encaminhamento"
                  />
                </div>

              </div>

              <div class="col-12 mt-5" v-else-if="(formData.result && formData.result.tipo_status && formData.result.tipo_status.id == 66)">
                  <ed-alert
                    type="success"
                    :description="'Essa consulta foi LIBERADA em '+toDate(formData.result.updated_at)"
                    title="Atenção"
                  />
                  <div class="col-12  mt-4 text-center">
                    <ed-button
                      icon="fa fa-print"
                      type="success"
                      title="Clique Aqui para Imprimir"
                      value="Imprimir ASO"
                      @click="onGuia"
                    />
                  </div>
              </div>

              <div class="col-12 mt-5 text-left" v-else-if="(formData.result && formData.result.tipo_status && formData.result.tipo_status.id == 194)">
                  <ed-alert
                    type="warning"
                    description="Essa consulta está aguardando processamento. Espere alguns minutos e atualize essa página para verificar o andamento do registro da consulta."
                    title="Atenção"
                  />
              </div>

               <div class="col-12 mt-5 text-left" v-else-if="(formData.result && formData.result.tipo_status && formData.result.tipo_status.id == 195)">
                  <ed-alert
                    type="error"
                    :description="'Erro ao registrar a consulta: '+formData.result.info"
                    title="Atenção"
                  />
              </div>

            </div>
        </div>
			</ed-form>

      <el-tabs type="border-card" v-model="tabSelected">
        <el-tab-pane label="Exames Complementares" name="tab-exames" v-if="formData.result && formData.result.tipo_status && formData.result.tipo_status.id != 194 && formData.result.tipo_status.id != 195">
          <span slot="label"><i class="fa fa-stethoscope"></i> Exames Complementares</span>
          <Exames/>
        </el-tab-pane>

        <el-tab-pane label="Riscos Ocupacionais" name="tab-riscos" v-if="formData.result && formData.result.tipo_status && formData.result.tipo_status.id != 194 && formData.result.tipo_status.id != 195">
          <span slot="label"><i class="fa fa-exclamation-triangle"></i> Riscos Ocupacionais</span>
          <Riscos/>
        </el-tab-pane>

        <el-tab-pane label="Acompanhamento" name="tab-acompanhamento">
          <span slot="label"><i class="fa fa-list-ol"></i> Acompanhamento</span>
          <Acompanhamento/>
        </el-tab-pane>

        <el-tab-pane label="Exames no PCMSO" name="tab-pcmso" v-if="formData.result">
            <span slot="label"><i class="fa fa-user-md"></i> Exames no PCMSO</span>
            <Pcmso :id_ghe="formData.result.ghe.id"/>
          </el-tab-pane>

          <el-tab-pane label="Histórico de Consultas" name="tab-historico"  v-if="formData.result">
            <span slot="label"><i class="fa fa-clock-o"></i> Histórico de Consultas</span>
            <Historico :funcionario="formData.result.funcionario" :id_funcao="formData.result.funcao.id"/>
          </el-tab-pane>

      </el-tabs>
  </div>
</template>

<script>

import Rest from "common/rest";
import Credenciada from './credenciada/index'
import EdForm from 'common/form'
import EdAlert from 'common/alert'
import EdButton from 'common/button'
import ItemsFormCadastrar from './_form/consulta-editar'

import Riscos from './riscos/index'
import Exames from './exames/index'
import Acompanhamento from './acompanhamento/index'
import Guia from 'appsEmpresa/consulta/_includes/guia'
import Pcmso from 'appsEmpresa/consulta/_includes/pcmso'
import Historico from 'appsEmpresa/consulta/_includes/historico'

export default {
  components: {EdForm,EdAlert,EdButton,Riscos,Exames,Acompanhamento,Guia,Pcmso,Historico},
  mixins: [Rest],
  data() {
    return {
      loadingContent:false,
      loadingSave:false,
      response:{},
      formDataItems:[],
      config:{
        tipo:[],
        readonly:{
          id_fdt:true,
          id_ghe:true,
          id_funcao:true,
          id_tipo_aso:true,
          data_age:false,
          funcionario:true,
          obs:true,
        }
      },
      formData:{
        id: 0,
        data_age:null,
        id_funcionario:null,
        funcionario:null,
        id_tipo_aso:null,
        id_tipo_status:null,
        id_funcao: null,
        id_fdt:null,
        id_ghe:null,
        exames:[],
        obs:null,
        result:null
      },
      pcmso:null,
      consulta_historico:null,
      showGuia:false,
      tabSelected:'tab-exames'
      
    };
  },

  created() {
  },

  mounted(){
  this.formDataItems = ItemsFormCadastrar;
  this.getConsulta();
  },

  methods: {

      onGuia(){
        this.showGuia = !this.showGuia;
      },

      getConsulta(){

        this.loadingContent = true;
        this.response = {};

        this.get('consulta/externa/'+this.$route.params.consulta).then((result) =>{
          result = result[0];

          this.loadingContent = false;
          this.response = result;

          if(result.status == 200){
            this.formData ={
              id: result.data.id,
              data_age:this.convertDate(result.data.data_age),
              funcionario:result.data.funcionario.nome,
              id_tipo_aso:result.data.tipo_aso.descricao+(result.data.periodicidade ? ' '+result.data.periodicidade+' MESES' : ''),
              id_tipo_status:result.data.tipo_status.id,
              id_funcao: result.data.funcao.nome,
              id_fdt:result.data.fdt.pcmso+' ('+result.data.fdt.descricao+')',
              id_ghe:result.data.ghe.ghe+' ('+result.data.ghe.descricao+')',
              obs:result.data.obs,
              result:result.data
            };

            if(result.data.tipo_status.id == '194' || result.data.tipo_status.id == '195'){
              this.tabSelected = 'tab-acompanhamento'
            }
          }
          else{
            if(result.status == 404)
              this.toRoute({name:'empresa.consulta'})
          }
        });
      },

      salvar(){

        this.loadingSave = true;
        this.response = {};

        this.post('consulta/externa/editar',this.formData).then((result) =>{

          result = result[0];

          this.loadingSave = false;
          this.response = result;

          if(result.status == 200){
            this.edMsg('Dados atualizados com sucesso');
          }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// editar.vue?fb00af32